module.exports = __webpack_public_path__ + "static/media/jazz-cash.3b478493.jpg";